import {
  Text,
  View,
  ScrollView,
  TouchableOpacity,
  Modal,
  Pressable,
  ActivityIndicator,
  TextInput,
} from "react-native";
import { useRouter, useLocalSearchParams } from "expo-router";
import { postAcceptOrder, changeMeter } from "../redux/actions/scaleactions";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import Icon from "react-native-vector-icons/FontAwesome";
import FooterComponent from "../component/footer";
import { useLanguage } from "./LanguageProvider";

export default function detailorder() {
  const router = useRouter();
  const { item: itemString, item2: itemParam } = useLocalSearchParams();

  const profile =
    useSelector((state: any) => state?.auth?.profile?.user?.[0]) || null;
  const [modalQuestionVisible, setModalQuestionVisible] = useState(false);
  const [modalSuccessVisible, setModalSuccessVisible] = useState(false);
  const [modalSuccessChangeMeterVisible, setModalSuccessChangeMeterVisible] =
    useState(false);
  const [modalInputFailVisible, setModalInputFailVisible] = useState(false);
  const [modalFailVisible, setModalFailVisible] = useState(false);
  const [modalChangeMeterVisible, setModalChangeMeterVisible] = useState(false);
  const [loadingresponse, setLoadingresponse] = useState(false);
  const [meter, setMeter] = useState("");
  const [meterChange, setMeterChange] = useState("");
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();
  const { t } = useLanguage();

  const item2 =
    typeof itemParam === "string" ? JSON.parse(itemParam) : itemParam;

  const item =
    typeof itemString === "string" ? JSON.parse(itemString) : itemString;

  // console.log("item", item);

  const handleSubmit = async () => {
    setLoadingresponse(true);
    try {
      const response = await dispatch(postAcceptOrder(item, profile) as any);
      if (response.success === true) {
        setModalSuccessVisible(true);
        // console.log("response.data", response.data);
      } else {
        setModalFailVisible(true);
        setMessage(response.message);
        console.log("error");
      }
    } catch (error) {
      console.log("error", error);
      setModalFailVisible(true);
      setMessage("เกิดข้อผิดพลาด");
    } finally {
      setLoadingresponse(false);
    }
  };

  // console.log("meterChange =>", meterChange);

  const onChangeMeter = async (text: string) => {
    setLoadingresponse(true);
    // console.log("text", text);
    const sanitizedText = text.replace(/[^0-9.]/g, "");

    // ตรวจสอบว่ามีจุดทศนิยมเกิน 1 จุดหรือไม่ ถ้ามีให้ใช้ค่าเดิม
    if ((sanitizedText.match(/\./g) || []).length <= 1) {
      setMeter(sanitizedText);
    }

    if (sanitizedText === "" || sanitizedText === "0") {
      setLoadingresponse(false);
      setModalInputFailVisible(true);
      return;
    }

    let updatedItem = { ...item, meter_change: sanitizedText };

    const response = await dispatch(changeMeter(updatedItem, profile) as any);
    if (response.success === true) {
      setModalSuccessChangeMeterVisible(true);
      setMeterChange(response?.meter_change);
      setLoadingresponse(false);
      // console.log("response.data", response.data);
    } else {
      setModalFailVisible(true);
      setMessage(response.message);
      setMeterChange("");
      setLoadingresponse(false);
      console.log("error");
    }
  };

  return (
    <>
      <View className="flex-1 bg-[#F17736] items-center justify-center">
        <View className="w-full h-[20%] bg-[#F17736] rounded-b-[50px]"></View>
        <View className="bottom-0 w-full h-[90%] bg-white rounded-t-[20px]"></View>

        <FooterComponent />

        {/* ScrollView ครอบเนื้อหาทั้งหมด */}
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "space-between",
            padding: 20,
          }}
          showsVerticalScrollIndicator={false}
          className="absolute mt-2 top-0 w-[90%] h-[90%] px-2 bg-white rounded-2xl border border-gray-200 shadow-md"
        >
          <View className="w-full items-center justify-center border-b border-gray-300 pb-1">
            <Text className="text-2xl font-kanit py-2">
              {/* รายละเอียดเพิ่มเติม */}
              {t("detail_order")}
            </Text>
          </View>

          <View className="w-full flex-1 pt-2">
            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* ชื่อ */}
                {t("name")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.order_name ? item?.order_name : t("no_data")}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* Order No. */}
                {t("order_number")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.order_number ? item?.order_number : t("no_data")}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* Matcode */}
                {t("matcode")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.material_code ? item?.material_code : t("no_data")}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* จำนวน */}
                {t("quantity")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {/* {item?.meter ? item?.meter : t("no_data")} M */}
                  {/* {item?.meter_change ? item?.meter_change : item?.meter}{" "} */}
                  {meterChange ? meterChange : item?.meter}{" "}
                  {item?.unit ? item?.unit : ""}
                </Text>
                <TouchableOpacity
                  // onPress={() => setModalChangeMeterVisible(true)}
                  onPress={() => setModalChangeMeterVisible(true)}
                >
                  <Icon name="pencil" size={24} color="#F17736" />
                </TouchableOpacity>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* หมายเลขภาชนะ */}
                {t("container_number")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.container_id ? item?.container_id : t("no_data")}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* ประเภทงาน */}
                {t("type")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.type === "good"
                    ? // ? "งานดี"
                      t("good")
                    : item?.type === "waste"
                    ? // ? "งานเสีย"
                      t("waste")
                    : "Wip"}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* ผู้ร้องขอ */}
                {t("employee_request")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.emp_name ? item?.emp_name : t("no_data")}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* วัน-เวลาที่ร้องขอ */}
                {t("date_time_request")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {/* {item?.date + " - " + item?.time + " น."} */}
                  {item?.date ? item?.date : t("no_data")} -{" "}
                  {item?.time ? item?.time : t("no_data")} น.
                </Text>
              </View>
            </View>
          </View>

          <View className="w-full items-center justify-center py-2 border-t pt-5 border-gray-300">
            <TouchableOpacity
              // onPress={() => router.push("/screens/retrieve")}
              // onPress={() =>
              //   router.push({
              //     pathname: "/screens/retrieve",
              //     params: { item: JSON.stringify(item), item2: JSON.stringify(item2) },
              //   })
              // }
              onPress={() => setModalQuestionVisible(true)}
              className="w-full bg-[#58d68d] py-3 rounded-xl items-center shadow-sm"
            >
              <Text className="text-white text-lg font-kanit">
                {/* รับงาน/ชั่งน้ำหนัก */}
                {t("accept_work")}
              </Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </View>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalFailVisible}
        onRequestClose={() => setModalFailVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="exclamation-circle" size={28} color="#ec7063" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {/* ผิดพลาด */}
                {t("error")}
              </Text>
            </View>

            <Text className="text-center text-gray-600 font-kanit mb-6">
              {message ? message : t("message_error")}
            </Text>

            <View className="flex-row justify-around">
              {/* Confirm Button */}
              <Pressable
                className="flex-1 bg-[#58d68d] py-2 rounded-lg mx-1"
                onPress={() => {
                  setModalFailVisible(false);
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {/* ยืนยัน */}
                  {t("confirm")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalSuccessVisible}
        onRequestClose={() => setModalSuccessVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            {/* Header */}
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="check-circle" size={28} color="#58d68d" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {/* สำเร็จ */}
                {t("success")}
              </Text>
            </View>

            {/* Message */}
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {/* คุณได้รับงานสำเร็จ */}
              {t("you_have_received_work_successfully")}
            </Text>

            {/* Buttons */}
            <View className="flex-row justify-around">
              {/* Confirm Button */}
              <Pressable
                className="flex-1 bg-[#58d68d] py-2 rounded-lg mx-1"
                // onPress={() => {
                //   setModalSuccessVisible(false);
                //   router.push("/screens/selectscale");
                //   router.push({
                //     pathname: "/screens/retrieve",
                //     params: { item: JSON.stringify(item), item2: JSON.stringify(item2) },
                //   });
                // }}
                onPress={() => {
                  if (item.type === "wip") {
                    setModalSuccessVisible(false);
                    router.push({
                      pathname: "/screens/scancheck",
                      params: {
                        item: JSON.stringify(item),
                        item2: JSON.stringify(item2),
                      },
                    });
                  } else {
                    setModalSuccessVisible(false);
                    router.push({
                      pathname: "/screens/retrieve",
                      params: {
                        item: JSON.stringify(item),
                        item2: JSON.stringify(item2),
                      },
                    });
                  }
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {/* ยืนยัน */}
                  {t("confirm")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalQuestionVisible}
        onRequestClose={() => setModalQuestionVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            {/* Header */}
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="question-circle" size={28} color="#58d68d" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {/* ยืนยัน */}
                {t("confirm")}
              </Text>
            </View>

            {/* Message */}
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {/* คุณต้องการรับงานนี้ใช่หรือไม่? */}
              {t("question_accept_work")}
            </Text>

            {/* Buttons */}
            <View className="flex-row justify-around">
              <Pressable
                className="flex-1 bg-gray-300 py-2 rounded-lg mx-1"
                onPress={() => {
                  setModalQuestionVisible(false);
                }}
              >
                <Text className="text-center text-gray-700 font-kanit">
                  {/* ไม่ใช่ */}
                  {t("cancel")}
                </Text>
              </Pressable>

              <Pressable
                className="flex-1 bg-[#58d68d] py-2 rounded-lg mx-1"
                onPress={() => {
                  handleSubmit();
                  setModalQuestionVisible(false);
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {/* ใช่ */}
                  {t("confirm")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={loadingresponse}
        onRequestClose={() => setLoadingresponse(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          {/* Header */}
          <View className="flex items-center justify-center pb-3">
            <ActivityIndicator size="large" color="#F17736" />
            <Text className="text-center text-xl font-kanit text-white pl-2 pt-2">
              {/* กำลังส่งข้อมูล... */}
              {t("loading_send_data")}
            </Text>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalChangeMeterVisible}
        onRequestClose={() => setModalChangeMeterVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="exclamation-circle" size={28} color="#ec7063" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {/* แจ้งเตือน */}
                {t("changemeter")}
              </Text>
            </View>

            <Text className="text-center text-gray-600 font-kanit mb-3">
              {/* กรุณาเปลี่ยนจำนวนใหม่ */}
              {t("please_change_quantity")}
            </Text>

            <TextInput
              className="w-full bg-gray-100 text-gray-700 font-kanit rounded-xl px-4 py-3 mb-4 text-center text-2xl"
              placeholder={t("enter_new_quantity")}
              value={meter}
              // defaultValue={item?.meter ? item?.meter : ""}
              onChangeText={(text: any) => {
                setMeter(text);
              }}
              keyboardType="decimal-pad"
              selectTextOnFocus={false}
            />

            <View className="flex-row justify-around">
              <Pressable
                className="flex-1 bg-gray-300 py-2 rounded-lg mx-1"
                onPress={() => {
                  setMeter("");
                  setModalChangeMeterVisible(false);
                }}
              >
                <Text className="text-center text-gray-700 font-kanit">
                  {/* ยกเลิก */}
                  {t("cancel")}
                </Text>
              </Pressable>
              {/* Confirm Button */}
              <Pressable
                className="flex-1 bg-[#58d68d] py-2 rounded-lg mx-1"
                onPress={() => {
                  onChangeMeter(meter);
                  setModalChangeMeterVisible(false);
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {/* ยืนยัน */}
                  {t("confirm")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalSuccessChangeMeterVisible}
        onRequestClose={() => setModalSuccessChangeMeterVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            {/* Header */}
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="check-circle" size={28} color="#58d68d" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {/* สำเร็จ */}
                {t("success")}
              </Text>
            </View>

            {/* Message */}
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {/* คุณเปลี่ยนจำนวนสำเร็จ */}
              {t("you_have_changed_the_quantity_successfully")}
            </Text>

            {/* Buttons */}
            <View className="flex-row justify-around">
              {/* Confirm Button */}
              <Pressable
                className="flex-1 bg-[#58d68d] py-2 rounded-lg mx-1"
                onPress={() => {
                  setModalSuccessChangeMeterVisible(false);
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {/* ยืนยัน */}
                  {t("confirm")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalInputFailVisible}
        onRequestClose={() => setModalInputFailVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="exclamation-circle" size={28} color="#ec7063" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {/* ผิดพลาด */}
                {t("error")}
              </Text>
            </View>

            <Text className="text-center text-gray-600 font-kanit mb-6">
              {/* กรุณากรอกจำนวนใหม่ */}
              {t("please_enter_a_new_quantity")}
            </Text>

            <View className="flex-row justify-around">
              {/* Confirm Button */}
              <Pressable
                className="flex-1 bg-[#58d68d] py-2 rounded-lg mx-1"
                onPress={() => {
                  setModalInputFailVisible(false);
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {/* ยืนยัน */}
                  {t("confirm")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>
    </>
  );
}
